import { useEffect, useState } from "react";
import { db } from "../Firebase";
import { ChatsService, MessagesService } from '../Services';

function useChat(user, categories = []) {
  const [chats, setChats] = useState([]);

  useEffect(() => {
    if (user) {
      ChatsService.observeChats(user, categories, (querySnapshot) => {
        setChats([]);
        querySnapshot.docs.forEach((doc) => {
          MessagesService.getMessages(doc.id).then((chatMessages) => {
            setChats(oldValue => [
              ...oldValue,
              {
                key: doc.id,
                messages: chatMessages,
                ...doc.data(),
              }
            ]);
          });
        });
      });
    }
  }, [user]);

  return {
    chats,
  };
}

export default useChat;
